import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 4v16h10","key":"svg-0"}]]

const IconLetterL = createReactComponent('outline', 'letter-l', 'LetterL', __iconNode);

export default IconLetterL;